import MBAutor from '../components/MBAutor.vue';
import MbColorPicker from '../components/MbColorPicker.vue';
import MbData from '../components/MbData.vue';
import MbTextField from '../components/MbTextField.vue';

export default function (Vue) {
  Vue.component('mb-select-autor', MBAutor)
  Vue.component('mb-data', MbData)
  Vue.component('mb-text-field', MbTextField)
  Vue.component('mb-color-picker', MbColorPicker)
}
